import React, { Fragment, useState, useEffect } from 'react';
import styles from './Business.module.scss';
import PaginationTable from '../../components/table/pagination-table';
import TableHeader from '../../components/TableHeader/TableHeader';
import client from '../../api/client';
import {
	ToastSuccessStyles,
	ToastErrorStyles,
} from '../../constants/toastStyles';
import { ColumnSubsidiariesPer } from '../../types/TablesTypes/Subsidiaries';
import StatusView from '../../components/StatusView/StatusView';
import { useDispatch } from 'react-redux';
import { openToastAndSetContent } from '../../redux/actions/toast/toastActions';
import {
	closeLoader,
	openLoader,
} from '../../redux/actions/loader/loaderActions';
import useApi from '../../hooks/useApi';
import transactionsApi from '../../api/transactions';
import moment from 'moment';
import { numberWithCommas } from '../../utils/formatNumber';
import { Dayjs } from 'dayjs';
import FilterModal from '../../components/filterConfig/FilterModal';
import {
	dateNow,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from '../../utils/datefunction';

function Subs({ id, name }: { id: number; name: string }) {
	const [transactionsDetails, setTransactionDetails] = useState<any>([]);
	const [tableRow, setTableRow] = useState<any[]>();
	const gettransactionsApi = useApi(transactionsApi.getTransactions);
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();

	//PAGINATION
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);

	//FILTERING
	const [value, setValue] = useState('');
	const [dropdown, setDropdown] = useState(false);
	const [eventDate, setEventDate] = useState('');
	const [fromDate, setFromDate] = useState<Dayjs | null | string>('');
	const [toDate, setToDate] = useState<Dayjs | null | string>('');
	const [businessType, setBusinessType] = useState('');
	const [named, setName] = useState('');
	const [email, setEmail] = useState('');
	const [status, setStatus] = useState('');
	const [bearer, setBearer] = useState(false);

	const clearHandler = () => {
		setEventDate('');
		setFromDate('');
		setToDate('');
		setBusinessType('');
		setName('');
		setStatus('');
		setDropdown(false);
		setBearer(true);
	};

	useEffect(() => {
		if (eventDate === 'today') {
			setFromDate(dateNow);
			setToDate(dateNow);
		} else if (eventDate === 'last7days') {
			setFromDate(sevenDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === 'last30days') {
			setFromDate(thirtyDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === 'oneyear') {
			setFromDate(startOfYear);
			setToDate(endOfYear);
		} else {
			setFromDate('');
			setToDate('');
		}
	}, [eventDate]);

	const filteredArray = [
		{
			name: 'Email Address',
			value: email,
			setValue: setEmail,
		},

		{
			name: 'Business Type',
			value: businessType,
			setValue: setBusinessType,
			selective: [{ name: 'Individual' }, { name: 'Company' }],
		},
		{
			name: 'Status',
			value: status,
			setValue: setStatus,
			selective: [
				{ name: 'New' },
				{ name: 'Active' },
				{ name: 'Pending-Verification' },
				{ name: 'Pending-Approval' },
			],
		},
	];
	useEffect(() => {
		dispatch(openLoader());
		client
			.get(
				`subsidiary/all/paginated?businessname=${name}&name=${named}&status=${status}&email=${email}&businessType=${businessType}&fromdate=${fromDate}&todate=${toDate}&limit=${rowsPerPage}&page=${pageNumber}`
			)
			.then((res: any) => {
				// console.log("paginated", res?.data);
				setTransactionDetails(res?.data);
				dispatch(closeLoader());
				setBearer(false);
			})
			.catch((error) => {
				dispatch(closeLoader());
				setIsLoading(false);
				if (error.response) {
					const message = error?.response?.data?.message;
					dispatch(
						openToastAndSetContent({
							toastStyles: ToastErrorStyles,
							toastContent: message,
						})
					);
				} else if (error.request) {
					console.log(error.request);
				} else {
					console.log('Error', error.message);
				}
			});
	}, [bearer, named, pageNumber, rowsPerPage]);

	useEffect(() => {
		setPageNumber(transactionsDetails?.currentPage || 1);
		setPreviousPage(transactionsDetails?.previousPage);
		setNextPage(transactionsDetails?.nextPage);
	}, [transactionsDetails]);

	const dataTransactions = () => {
		const tempArr: any[] = [];
		transactionsDetails?.items
			?.slice(0)
			.reverse()
			.forEach((subsidiaries: any, index: number) => {
				return tempArr.push({
					businessName: subsidiaries?.name,
					email: subsidiaries?.email,
					businessType: subsidiaries?.businessType,
					country: subsidiaries?.country,
					users: subsidiaries?.userCount,
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataTransactions);
	}, [transactionsDetails?.items]);

	const itemLength = transactionsDetails?.items?.length;
	return (
		<Fragment>
			<TableHeader
				pageName='Subsidiaries'
				data={transactionsDetails?.items}
				dataLength={transactionsDetails?.totalItems}
				value={named}
				setValue={setName} 
				dropdown={dropdown}
				setDropdown={setDropdown}
				placeHolder='Search by business name'
				FilterComponent={
					<FilterModal
						eventDate={eventDate}
						setEventDate={setEventDate}
						dropdown={dropdown}
						setDropdown={setDropdown}
						setFromDate={setFromDate}
						setToDate={setToDate}
						fromDate={fromDate}
						toDate={toDate}
						setBearer={setBearer}
						clearHandler={clearHandler}
						filteredArray={filteredArray}
					/>
				}
			/>

			{gettransactionsApi.loading ? (
				<div className={styles.loading} />
			) : (
				<PaginationTable
					data={tableRow ? tableRow : []}
					columns={ColumnSubsidiariesPer ? ColumnSubsidiariesPer : []}
					emptyPlaceHolder={
						transactionsDetails?.totalItems == 0
							? 'You currently do not have any subsidaries'
							: 'Loading...'
					}
					value={value}
					total={transactionsDetails?.totalItems}
					totalPage={transactionsDetails?.totalPages}
					pageNumber={pageNumber}
					setPageNumber={setPageNumber}
					nextPage={nextPage}
					setNextPage={setNextPage}
					previousPage={previousPage}
					setPreviousPage={setPreviousPage}
					rowsPerPage={rowsPerPage}
					setRowsPerPage={setRowsPerPage}
				/>
			)}
		</Fragment>
	);
}

export default Subs;
